module.exports = __webpack_public_path__ + "img/60.84350cf7.jpg";